module.exports = __webpack_public_path__ + "img/img10.ccaa18ca.svg";